import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { API_V2, getSomethingPaginated } from './types';

export const getJobs = async (accountId: number): Promise<Job[]> => {
  return await getSomethingPaginated<Job>(API_V2, `/accounts/${accountId}/jobs/`, {
    include_related: JSON.stringify(['most_recent_completed_run']),
  });
};

export const useJobs = ({ accountId }: { accountId?: number }) => {
  const enabled = !!accountId;
  return useQuery<Job[], AxiosError>({
    queryKey: ['jobs', { accountId }],
    queryFn: () => getJobs(accountId ?? 0),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export interface Job {
  id?: number | null;
  name: string;
  environment_id: number;
  account_id: number;
  project_id: number;
  project: any | null;
  most_recent_completed_run: any | null;
}
